import { Modal } from '@components';
import { useScreenSize } from '@hooks';
import { userApi } from '@store';
import { Button, Flex, theme, Typography } from '@styles';
import { ProfileTemplate } from '@templates';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ChooseAvatarModal, SettingsForm } from './components';
import { avatars } from './SettingsPage.layoutProps';
import {
  getChooseAvatarFirstButtonStyles,
  getChooseAvatarModalStyles,
} from './SettingsPage.styles';

const SettingsPage = () => {
  const { i18n } = useTranslation();
  const { isTabletSM } = useScreenSize();

  const [isVisible, setIsVisible] = useState(false);
  const [activeAvatar, setActiveAvatar] = useState(avatars[0]);

  const { data } = userApi.useGetUserQuery();
  const [changeAvatar] = userApi.useChangeAvatarMutation();
  const openModal = () => {
    setIsVisible(true);
  };

  useEffect(() => {
    if (data?.data.avatar) {
      setActiveAvatar(
        avatars.find((avatar) => data?.data.avatar === avatar.image) ||
          avatars[0]
      );
    }
  }, [avatars, data?.data.avatar]);

  const handleChangeAvatar = async () => {
    await changeAvatar({
      avatar: activeAvatar.image,
      username: data?.data.username,
    });
  };

  return (
    <ProfileTemplate>
      <Flex alignItems="center" gap={isTabletSM ? 20 : 40} mb={48}>
        <Flex
          alt="avatar"
          backgroundImage={activeAvatar.image}
          backgroundRepeat="no-repeat"
          backgroundSize="cover"
          borderRadius={56}
          flexShrink={0}
          height={112}
          width={112}
        />
        <Button onClick={openModal} variant="textButton">
          <Typography
            color={theme.colors.schoolBusYellow[100]}
            variant="MS-semibold-s18-lh19"
          >
            {i18n.t('ProfilePage.ChangeAvatar')}
          </Typography>
        </Button>
      </Flex>
      <SettingsForm />
      <Modal
        firstButtonProps={getChooseAvatarFirstButtonStyles({ isTabletSM })}
        firstButtonText={i18n.t('ProfilePage.Save').toUpperCase()}
        isVisible={isVisible}
        modalContainerProps={getChooseAvatarModalStyles({ isTabletSM })}
        modalMaxHeight={isTabletSM ? 'auto' : 845}
        onFirstButtonClick={handleChangeAvatar}
        setModalVisible={setIsVisible}
        withBottomButtons
      >
        <ChooseAvatarModal
          activeElement={activeAvatar}
          setActiveElement={setActiveAvatar}
        />
      </Modal>
    </ProfileTemplate>
  );
};

export default SettingsPage;
